import { useForm } from 'react-hook-form';
import { useEffect, useState } from 'react';
import { useMediaQuery } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { TextField } from '@material-ui/core';
import toast from 'react-hot-toast';

import { setChangePassword } from '../Services/Profile';

import  './Styles/ChangePassword.css';


interface FormChangePassword {
  Clave: string;
  ClaveNueva: string;
  ClaveNuevaConfirmed: string;
}

interface Usuario {
  clave: string;
  correo: string;
  nombres: string;
  objetivo: string;
  respondio: boolean;
  usuarioTestAsesoriaID: number;
}

function ChangePassword() {
  const [user, setUser] = useState<Usuario>();
  const navigate = useNavigate();
  const matches = useMediaQuery('(max-width: 650px)');
  const [claveStorage, setclaveStorage] = useState<string>();
  const [change, setChange] = useState<boolean>(false);

  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (localStorage.getItem('user')) {
      setUser(JSON.parse(localStorage.getItem('user')));
    }
  }, [change]);

  const handleChangePassword = (data: FormChangePassword) => {
    if (user) {
      if (
        data &&
        data.ClaveNueva === data.ClaveNuevaConfirmed &&
        data.Clave === user.clave
      ) {
        setChangePassword({
          Clave: user.clave,
          ClaveNueva: data.ClaveNueva,
          UsuarioTestAsesoriaID: user.usuarioTestAsesoriaID,
        }).then((response) => {
          toast.success('Contraseña cambiada con éxito');
          const userData = JSON.parse(localStorage.getItem('user'));
          userData.clave = data.ClaveNueva;
          localStorage.setItem('user', JSON.stringify(userData));
          setChange(!change);
        });
      } else {
        if (user.clave !== data.Clave) {
          return toast.error('Tu antigua contraseña no es la misma');
        }
        return toast.error('Confirma la contraseña');
      }
    }
  };

  useEffect(() => {
    if (user) {
      setclaveStorage(user.clave);
    }
  }, [change, user]);

  return (
    <div className="cpw-page">
      {/* Header */}
      <div className="cpw-header">
        <button className="cpw-back-btn" onClick={() => navigate('/perfil')}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
        <div className="cpw-header-text">
          <span className="cpw-header-label">Seguridad</span>
          <h2 className="cpw-header-title">Cambiar Contraseña</h2>
        </div>
      </div>

      {/* Icon */}
      <div className="cpw-icon-wrap">
        <div className="cpw-icon">
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
            <path d="M7 11V7a5 5 0 0 1 10 0v4" />
          </svg>
        </div>
      </div>

      {/* Form Card */}
      <form className="cpw-card" onSubmit={handleSubmit(handleChangePassword)}>
        <div className="cpw-fields">
          <TextField
            type="password"
            label="Antigua contraseña"
            variant="outlined"
            className="textarea"
            {...register('Clave', { required: 'Este campo es requerido' })}
            required
            fullWidth
          />
          <TextField
            label="Nueva contraseña"
            variant="outlined"
            type="password"
            className="textarea"
            {...register('ClaveNueva', { required: 'Este campo es requerido' })}
            required
            fullWidth
          />
          <TextField
            label="Confirmar contraseña"
            variant="outlined"
            type="password"
            className="textarea"
            {...register('ClaveNuevaConfirmed', { required: 'Este campo es requerido' })}
            required
            fullWidth
          />
        </div>

        {/* Tip */}
        <div className="cpw-tip">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M12 2a10 10 0 1 0 0 20 10 10 0 0 0 0-20z" />
            <path d="M12 16v-4" />
            <path d="M12 8h.01" />
          </svg>
          <p>Usa letras mayúsculas, minúsculas, números y caracteres especiales para mayor seguridad.</p>
        </div>

        <button className="cpw-submit" type="submit">
          Guardar nueva contraseña
        </button>
      </form>
    </div>
  );
}

export default ChangePassword;
